import { JobAdminType } from "@/graphql.ts";

export function getJobAdminTypeDisplayName(type: JobAdminType) {
  switch (type) {
    case JobAdminType.PlaybookEvent:
      return "Playbook Event";
      break;
    case JobAdminType.WorkflowEvent:
      return "Processor Session";
      break;
  }
}
